import type React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import SumsubScreen from './SumsubScreen'

type KycNavigatorProps = {}

const KycNavigator: React.FC<KycNavigatorProps> = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${path}/sumsub`}>
        <SumsubScreen />
      </Route>
    </Switch>
  )
}

export default KycNavigator
